import type { FC } from 'react';
import { NAV_LINKS } from '@/lib/config/system';
import type { TNavLink, TWithClassName } from '@/lib/interfaces/shared';
import cn from '@/lib/packages/cn';
import Link from '@/ui/Link';

type TNavList = TWithClassName & {
  onClose?: (value: boolean) => void;
};

const NavList: FC<TNavList> = ({ className, onClose }) => {
  const printNavLink = (link: TNavLink) => {
    const { id, label, href } = link;

    if (href?.startsWith('#')) {
      // Native hash navigation; close menu after scroll begins
      return (
        <li key={id}>
          <a
            href={href}
            className='font-semibold capitalize group relative text-primary-foreground before:absolute before:-bottom-1.5 before:left-0 before:h-0.5 before:w-0 before:bg-current before:transition-all before:duration-300 before:ease-out hover:before:w-full'
            onClick={() => setTimeout(() => onClose?.(false), 200)}
          >
            {label}
          </a>
        </li>
      );
    }

    return (
      <li key={id}>
        <Link
          href={href}
          variant='primary'
          className='font-semibold capitalize'
          onClick={onClose ? () => onClose(false) : undefined}
        >
          {label}
        </Link>
      </li>
    );
  };

  return <ul className={cn('flex items-center text-xl lg:text-base/6', className)}>{NAV_LINKS.map(printNavLink)}</ul>;
};

export default NavList;
